import React, { lazy, Suspense } from "react";

import { RemoteLogErrorBoundary } from "~/components/common/remote-log-error-boundary";
import { useIntlDocumentTitle } from "~/hooks/use-document-title";
import { useScrollToTop } from "~/hooks/use-scroll-to-top";

const LazyOffer = lazy(() => import("./offer"));

export function OfferPage() {
  useIntlDocumentTitle("offer.header");
  useScrollToTop();

  return (
    <RemoteLogErrorBoundary component="offer_page">
      <Suspense fallback={null}>
        <LazyOffer />
      </Suspense>
    </RemoteLogErrorBoundary>
  );
}
